export const SITE_NAME = "Howards Medical";

export const API_BASE =
  import.meta.env.VITE_API_BASE ?? "http://localhost:8000/api/v1";

export const FRONT_END_ROOT =
  import.meta.env.VITE_FRONTEND_ROOT ?? "http://web-dev.localhost:5000";

export const KEYCLOAK_URL =
  import.meta.env.VITE_KEYCLOAK_URL ?? "http://erp-app.localhost/auth";

//export const KEYCLOAK_URL = `${FRONT_END_ROOT}/auth`
export const KEYCLOAK_REALM = "HowardsMedical";
export const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "web";

export const S3_ENDPOINT =
  import.meta.env.VITE_S3_URL ?? "http://erp-app.localhost:9000";

export const S3_REGION = "us-west-2";

export const SILENT_CHECK_SSO_REDIRECT_PATH = import.meta.env.VITE_SILENT_CHECK_SSO_REDIRECT_PATH ?? 'silent-check-sso.html';

// set `VITE_ERP_NEXT_IMPORT_MODE` when you are compiling these assets to be
// imported into erp-next via its `howards_app`
export const ERP_NEXT_IMPORT_MODE = import.meta.env.VITE_ERP_NEXT_IMPORT_MODE ?? false